import { Input, Typography } from "antd";
import { React, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import "rsuite/dist/rsuite.min.css";

const { Text } = Typography;

const ItemAmount = ({
    propAmount,
    onSet,
    onSetComment,
    onCheckboxChange,
    isSelected,
    i,
    currency,
    isDisabled,
}) => {
    const [amount, setAmount] = useState();
    const [comment, setComment] = useState();
    const [openComment, setOpenComment] = useState(false);

    return (
        <div className="grid mt-2 md:grid-cols-3 grid-cols-2 justify-between items-center w-full gap-y-5 gap-x-2">
            <div className="col-span-1 items-center flex gap-2">
                {isDisabled && (
                    <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={onCheckboxChange}
                        name=""
                        id=""
                    />
                )}

                <Text className="font-normal text-[#031339] text-[12px]">
                    {i?.name}
                </Text>
            </div>
            <div className="col-span-1 md:block hidden">
                <Input
                    placeholder="Comment (Optional)"
                    className="bg-[#F0F0F0]"
                    onChange={(e) => {
                        onSetComment(e.target?.value);
                        setComment(e.target?.value);
                    }}
                    value={comment || ""}
                />
            </div>
            <div className="md:col-span-1 col-span-1 flex flex-row gap-2 ">
                <div className="w-[50%] md:hidden flex items-center">
                    <button
                        className={`${
                            openComment
                                ? "bg-[#D748481C] text-[#D74848]"
                                : "bg-[#0095FF1C] text-[#0095FF]"
                        }  rounded-xl font-medium text-[7px] p-1`}
                        onClick={() => setOpenComment(!openComment)}>
                        {openComment ? "Close" : "Add Note"}
                    </button>
                </div>
                <div className="relative w-[100%] rounded-md border border-[#f3f3f3]">
                    <p className="bg-[#f5f5f5] absolute px-3 py-1">{currency?.symbol}</p>
                    <input
                        type="text"
                        className="w-full text-right p-1 outline-none rounded-md border"
                        placeholder="0.00"
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value)) {
                                setAmount(value);
                                onSet(Number(value));
                            }
                        }}
                        onBlur={() => {
                            if (!isNaN(amount)) {
                                const formattedValue = Number(amount).toFixed(2);
                                setAmount(formattedValue);
                                onSet(Number(formattedValue));
                            }
                        }}
                        onFocus={() => {
                            if (Number(amount ?? propAmount) <= 0) {
                                setAmount("");
                            }
                        }}
                        disabled={isDisabled}
                        defaultValue={propAmount}
                        value={amount ?? propAmount}
                    />
                </div>
            </div>
            <div
                className={`col-span-2 md:hidden block ${
                    openComment ? "block" : "hidden"
                }`}>
                <Input
                    placeholder="Comment (Optional)"
                    className="bg-[#F0F0F0]"
                    onChange={(e) => {
                        onSetComment(e.target?.value);
                        setComment(e.target?.value);
                    }}
                    value={comment || ""}
                />
            </div>
        </div>
    );
};

export default ItemAmount;
